import { patternFormatter } from 'react-number-format';

// Телефон в форме — 10 цифр номера после +7; на бэкенд уходит «7XXXXXXXXXX»

export const PHONE_FORMAT = '+7 (###) ###-##-##';
export const PHONE_PLACEHOLDER = '+7 (___) ___-__-__';
export const PHONE_MASK_CHAR = '_';
// С чего начинается текст поля, набранный через маску
const PHONE_PREFIX = '+7 (';

const NATIONAL_LENGTH = 10;

// Номер без кода страны: «79991234567», «8 999 123-45-67», «+7 (999) 123-45-67» → «9991234567».
// Ведущая 7 — всегда код страны: так PhoneInput отдаёт и неполный номер («799» → «99»)
export function nationalDigits(phone: string): string {
  const digits = phone.replace(/\D/g, '');
  const national = /^(?:7|8\d{10}$)/.test(digits) ? digits.slice(1) : digits;
  return national.slice(0, NATIONAL_LENGTH);
}

// Значение для формы и запроса; пустой ввод — пустая строка
export const toStoredPhone = (national: string): string => (national ? `7${national}` : '');

// Телефон для показа: «79991234567» → «+7 (999) 123-45-67»; пустой — пустая строка
export const formatPhone = (phone: string): string =>
  patternFormatter(nationalDigits(phone), { format: PHONE_FORMAT, mask: PHONE_MASK_CHAR });

export const isCompletePhone = (national: string): boolean => national.length === NATIONAL_LENGTH;

// Полный номер, вставленный или подставленный браузером мимо маски: «79991234567», «+79991234567», «8 999 123-45-67»
export const isPastedFullNumber = (input: string): boolean =>
  !input.startsWith(PHONE_PREFIX) && /^[78]\d{10}$/.test(input.replace(/\D/g, ''));
